<template lang="pug">
  .box-row-pc
    .item-header
      .item-title
        .unpin(v-if="item.un_pin === 2")
          i.fa.fa-star
        img(:src="item.private_community.icon" v-if="item.private_community.icon && item.private_community.icon !== null && item.private_community.icon.length")
        img(src="../../assets/images/faces/avt-default.png" v-else)
        span(v-if="item.position === 2") {{ item.private_community.name }} (TRỢ LÝ)
        span(v-else) {{ item.private_community.name }}
      .item-function(v-if="$isMobile()" :class="[(keyActive === 'itemPC_' + item.pc_id && isPopover)? 'open-popover' : '']" @click="clickPopover('itemPC_' + item.pc_id)")
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover(ref="popoverPC")
          span(v-if="item.un_pin === 2" @click="unPinPC(item, 1)") Bỏ ghim cộng đồng
          span(v-if="item.un_pin === 1" @click="unPinPC(item, 2)") Ghim cộng đồng
      .item-function.and-hover(v-else)
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover(ref="popoverPC")
          span(v-if="item.un_pin === 2" @click="unPinPC(item, 1)") Bỏ ghim cộng đồng
          span(v-if="item.un_pin === 1" @click="unPinPC(item, 2)") Ghim cộng đồng
    .item-body(v-if="lstClasses && lstClasses.length > 0")
      .row
        .box-custom-padding
          .item-classes-pc.col-md-2.col-sm-2.col-xs-6(v-for="(classes, index) in lstClasses")
            ItemClasses(:item="classes" :key="increment" v-on:onFlagDeleted="onFlagDeleted" v-on:onDeleted="onDeleted" v-on:onUnpinClass="unpinClass" v-on:copyLinkJoin="doCopy" v-on:resetPopoverClass="resetPopoverClass" :keyPopoverClass="keyPopoverClass" :keyActiveClass="keyActiveClass" :keySmart="keySmart")
    .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import ItemClasses from '../ClassesMe/itemClasses'
export default {
  components: {
    MdNotification,
    ItemClasses
  },
  props: {
    item: Object,
    keyPopover: {
      type: Boolean,
      default: false
    },
    keyActive: ''
  },
  data() {
    return {
      lstClasses: [],
      message: this.$t('home.comming_soon'),
      isPopover: this.keyPopover,
      increment: 0,
      loader: null,
      keyActiveClass: '',
      keyPopoverClass: false,
      keySmart: 0
    }
  },
  async mounted () {
    if (this.$route.params.reload === 1) {
      console.log('reload')
    }
    this.lstClasses = []
    await this.getAllClassPC()
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    autoIncrement() {
      this.increment++
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem
    },
    clickPopover(itemActive) {
      if (this.keyActive !== '' && this.keyActive !== itemActive) {
        this.isPopover = true
      } else this.isPopover = !this.isPopover
      this.$emit('resetPopover', itemActive, this.isPopover)
    },
    resetPopoverClass(itemActive, isPopover, isSmart) {
      this.increment++
      this.keyActiveClass = itemActive
      this.keyPopoverClass = isPopover
      this.keySmart = isSmart
    },
    unPinPC(item, unPin) {
      this.$emit('unPinPC', item, unPin)
    },
    async unpinClass(item, unPin) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      var objInput = {
        un_pin_class: unPin
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput},
        update: (store, { data: { update_pc_user } }) => {
          if (update_pc_user.affected_rows) {
            this.loader.hide()
            this.$modal.hide('dialog')
            var index = this.lstClasses.findIndex(function(obj) { return obj.pc_id === item.pc_id && obj.classes_id === item.classes_id })
            this.lstClasses[index].un_pin_class = unPin
            this.sortClassesRefresh()
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    },
    url(pcName, clName, clID) {
      let url = window.location.origin + '/' + this.$router.resolve({name: 'join_classes'}).href + 'join-classes/'
      let seoUrl = url + this.$mycontroller.doSanitizeTitle(pcName) + '/' + this.$mycontroller.doSanitizeTitle(clName) + '-' + clID + '/yeucauthamgia'
      return seoUrl
    },
    doCopy(itemClass) {
      var url = this.url(this.item.private_community.name, itemClass.classes.name, itemClass.classes_id)
      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()
      input.setSelectionRange(0, 99999)
      try {
        var successful = document.execCommand('copy')
        document.body.removeChild(input)
        if (successful) this.showNotification('Copy thành công', 'success', 'top', 'right', 2000)
        else this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      } catch (err) {
        this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      }
    },
    async getAllClassPC () {
      var variables = {
        where: {
          user_id: {'_eq': this.$store.getters.user},
          pc_id: {'_eq': this.item.pc_id},
          is_delete: {_eq: false}
        }
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CLASS_USER_JOIN_STUDENT),
        fetchPolicy: 'no-cache',
        variables: variables
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      if (data && data !== null) {
        this.lstClasses = data.pc_user
        this.sortClassesRefresh()
      }
    },
    sortClassesRefresh() {
      this.lstClasses.sort(this.compareStatus)
    },
    compareStatus(a, b) {
      var statusA = a.status
      var statusB = b.status
      let comparison = 0
      if (statusA === 3) statusA = 0
      else if (statusB === 3) statusB = 0
      if (a.un_pin_class > b.un_pin_class) comparison = -3
      else if (a.un_pin_class < b.un_pin_class) comparison = 3
      else {
        if (statusA > statusB) {
          comparison = -2
        } else if (statusA < statusB) {
          comparison = 2
        } else {
          if (a.created_at > b.created_at) {
            comparison = -1
          } else if (a.created_at < b.created_at) {
            comparison = 1
          } else {
            comparison = 0
          }
        }
      }
      return comparison
    },
    async checkExerciseUserExist($exerciseID, $userID, $classID) {
      var isExists = -1
      var objWhere = {
        exercise_id: {'_eq': $exerciseID},
        user_id: {'eq': $userID},
        class_id: {'_eq': $classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_EXERCISE_USER_EXIST2),
        fetchPolicy: 'no-cache',
        variables: {
          where: objWhere
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      if (data && data.exercise_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.exercise_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    },
    async assignExerciseUser(exerciseIDs, userID, classID) {
      if (exerciseIDs !== null && exerciseIDs.length > 0) {
        for (let i = 0; i < exerciseIDs.length; i++) {
          var isExists = await this.checkExerciseUserExist(parseInt(exerciseIDs[i]), userID, classID)
          if (isExists === 2) {
            let objWhere = {
              exercise_id: {_eq: parseInt(exerciseIDs[i])},
              user_id: {_eq: userID},
              class_id: {_eq: classID}
            }
            let objInput = {
              is_delete: true,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_EXERCISE_USER),
              variables: {objWhere: objWhere, objInput: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          }
        }
      }
    },
    async updateDeletedUserPC(item, type) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      var objInput = {
        un_pin: 1,
        is_delete: true
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput},
        update: (store, { data: { update_pc_user } }) => {
          if (update_pc_user.affected_rows) {
            // assign exercise cho user
            if (type && type !== null) this.assignExerciseUser(item.classes.exercise_ids, item.user_id, item.classes_id)
            // lọc lại danh sách lớp học
            this.loader.hide()
            this.$modal.hide('dialog')
            this.lstClasses.splice(this.lstClasses.findIndex(function(obj) { return obj.pc_id === Number(item.pc_id) && obj.classes_id === Number(item.classes_id) && obj.user_id === item.user_id }), 1)
            this.sortClassesRefresh()
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      if (this.lstClasses.length === 0) this.$emit('onRemovePC', item)
    },
    onFlagDeleted(item) {
      this.$modal.show('dialog', {
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn xoá yêu cầu duyệt lớp học <b>' + item.classes.name + '</b> này không?',
        class: 'col-md-6 col-12 box-popup-confirm',
        buttons: [
          {
            title: 'Xác nhận',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: async () => {
              this.updateDeletedUserPC(item, null)
            }
          },
          {
            title: 'Hủy yêu cầu',
            class: 'btn btn-primary cancel-delete-dialog'
          }
        ]
      })
    },
    async deletedUserPC(item) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.DELETE_PC_USER),
        variables: {objWhere: objWhere},
        update: (store, { data: { delete_pc_user } }) => {
          if (delete_pc_user.affected_rows) {
            this.loader.hide()
            this.$modal.hide('dialog')
            this.lstClasses.splice(this.lstClasses.findIndex(function(obj) { return obj.pc_id !== item.pc_id && obj.classes_id !== item.classes_id && obj.user_id === item.user_id }), 1)
            this.sortClassesRefresh()
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
      if (this.lstClasses.length === 0) this.$emit('onRemovePC', item)
    },
    onDeleted(item, isDeleted) {
      var text = isDeleted ? 'xoá yêu cầu' : 'rời lớp học'
      this.$modal.show('dialog', {
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn ' + text + ' <b>' + item.classes.name + '</b> khỏi danh sách lớp học của mình không?',
        class: 'col-md-6 col-12 box-popup-confirm',
        buttons: [
          {
            title: 'Xác nhận',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: async () => {
              if (isDeleted) this.deletedUserPC(item)
              else this.updateDeletedUserPC(item, true)
            }
          },
          {
            title: 'Hủy yêu cầu',
            class: 'btn btn-primary cancel-delete-dialog'
          }
        ]
      })
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .box-classes-me{
    .box-info-pc{ padding-bottom: 15px; margin-bottom: 15px; border-bottom: 1px solid #B4B4B4;
    &:last-child{border: 0 none; padding-bottom: 0; margin-bottom: 0;}
      .item-header{
        .item-title{display: inline-block; position: relative; width: calc(100% - 25px);
          .unpin{display: inline-block; margin-right: 4px;  position: relative; top:2px;
            .fa-star{color: #9F6A28; font-size: 16px;}
          }
          img{border: 1px solid #969FAD; width: 16px; height: 16px; border-radius: 50%;margin-right: 8px;}
          span{ color: #9F6A28; font-weight: bold; font-size: 16px;}
        }
        .item-function{float: right; position: relative; cursor: pointer;
          .box-popover{position: absolute; top: 20px; right: 0; z-index: 1060; display: none; min-width: 150px; padding: 8px;  background: #F8F8F8 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; border-radius: 10px;
            span{display: block; font-size: 15px; color: #23180A;}
          }
          &.open-popover{
            .box-popover{display: block;}
          }
          &.and-hover:hover{
            .box-popover{display: block;}
          }
        }
      }
      .item-body{
        .box-custom-padding{float: left; width: 100%;padding-left: 8px; padding-right: 8px;
          .item-classes-pc{margin-top: 15px; padding-left: 8px; padding-right: 8px;}
        }
      }
    }
  }
@media screen and (min-width: 768px){
  
}
@media screen and (max-width: 768px){
  
}
</style>



// WEBPACK FOOTER //
// item.vue?b11df936